export default "__VITE_ASSET__33268ee8__"